export const SERVICES = [
  {
    key: "general",
    title: "General Dentistry",
    desc: "Check-ups, fillings, scaling and painless extractions using modern rotary instruments.",
    items: ["Dental check-up & X-ray", "Tooth-coloured fillings", "Scaling & polishing", "Extractions"],
  },
  {
    key: "cosmetic",
    title: "Cosmetic Dentistry",
    desc: "Smile design, whitening and veneers that look natural, never artificial.",
    items: ["Teeth whitening", "Ceramic veneers", "Smile designing", "Gum contouring"],
  },
  {
    key: "orthodontics",
    title: "Orthodontics",
    desc: "Braces and clear aligners for children, teens and adults with monthly reviews.",
    items: ["Metal & ceramic braces", "Clear aligners", "Retainers", "Growth guidance"],
  },
  {
    key: "root-canal",
    title: "Root Canal & Crowns",
    desc: "Single-sitting root canals with rotary endodontics and precise zirconia crowns.",
    items: ["Single-sitting RCT", "Zirconia & PFM crowns", "Post & core", "Bridges"],
  },
  {
    key: "implants",
    title: "Implants & Dentures",
    desc: "Replacing missing teeth with implants or comfortable, well-fitting dentures.",
    items: ["Single & multiple implants", "Full & partial dentures", "Flexible dentures", "Denture repairs"],
  },
  {
    key: "preventive",
    title: "Preventive & Kids Care",
    desc: "Fluoride, sealants and gentle first visits that keep children calm and cavity-free.",
    items: ["Fluoride application", "Pit & fissure sealants", "Habit breaking appliances", "Diet counselling"],
  },
];

export const TIME_SLOTS = [
  "09:30 AM",
  "10:30 AM",
  "11:30 AM",
  "12:30 PM",
  "04:00 PM",
  "05:00 PM",
  "06:00 PM",
  "07:00 PM",
];

export const TESTIMONIALS = [
  {
    name: "Ananya Deshpande",
    text: "I have always been terrified of dentists. The doctor explained every step before starting and my root canal was genuinely painless. The clinic is spotless.",
    treatment: "Root canal treatment",
  },
  {
    name: "Rahul Mehta",
    text: "Took my 6-year-old for her first filling. They were patient, playful and finished without a single tear. We now go as a family.",
    treatment: "Paediatric filling",
  },
  {
    name: "Sneha Kulkarni",
    text: "Got my aligners here instead of a big chain and paid far less. Same doctor at every visit, which made a huge difference.",
    treatment: "Clear aligners",
  },
];

export const HYGIENE = [
  {
    title: "Autoclave sterilization",
    desc: "Every instrument is pouched and cycled through a Class B autoclave before it reaches you.",
  },
  {
    title: "Single-use disposables",
    desc: "Gloves, suction tips, needles, masks and bibs are opened fresh in front of every patient.",
  },
  {
    title: "Surface & chair protocol",
    desc: "Chairs, handles and work surfaces are disinfected between appointments, with spaced-out slots.",
  },
  {
    title: "Filtered water lines",
    desc: "Dental unit water lines are flushed and treated daily so nothing but clean water touches your mouth.",
  },
];
